import React from "react";
import { BrowserRouter, Route, Router, Routes, Navigate  } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";

import Login from "./components/user/Login";
import Register from "./components/user/Register";
import Logout from "./components/user/Logout";
import UserList from "./components/user/user";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

import Page404 from "./components/404/404Page";
import Dashboard from "./components/Dashboard/Graph/Dashboard"; //user dashboard
import AdminDashboard from "./components/Dashboard/Graph/AdminDashboard"; // admin dashboard
import DetailStaff from "./components/user/detailsStaff";

import Designation from "./components/designation/designation";
import DetailDesignation from "./components/designation/detailDesignation";
import UpdateDesignation from "./components/designation/updateDesignation";

import Main from "./components/layouts/Main";

import AddPermission from "./components/role/AddPermission";
import DetailRole from "./components/role/DetailsRole";
import RoleList from "./components/role/role";
import InvoiceSetting from "./components/settings/invoiceSetting";
import WelcomePage from "./components/UI/welcomePage";
import GetAllUsers from "./components/user/GetAllUser";
import Department from "./components/department/Department.js";
import DetailDepartment from "./components/department/DetailsDepartment";
import CalculatePayroll from "./components/payroll/CalculatePayroll";

import PayslipList from "./components/payroll/PayslipList";
import Shift from "./components/shift/Shift";
import DetailShift from "./components/shift/ShiftDetails";
import EmploymentStatus from "./components/employmentStatus/EmploymentStatus";
import DetailEmploymentStatus from "./components/employmentStatus/EmploymentStatusDetails";
import Attendance from "./components/attendance/AddAttendance";
import Leave from "./components/leave/Leave";
import GetAllLeaves from "./components/leave/GetAllLeaves";
import DetailLeave from "./components/leave/DetailLeave";
import DetailAttendance from "./components/attendance/DetailAttendance";
import UserAttendance from "./components/attendance/UserAttendance";

import Account from "./components/account/account";
import BalanceSheet from "./components/account/balanceSheet";
import DetailAccount from "./components/account/detailAccount";
import IncomeStatement from "./components/account/incomeStatement";
import TrialBalance from "./components/account/trialBalance";

import AddTransaction from "./components/transaction/AddTransaction";
import DetailTransaction from "./components/transaction/detailTransaction";
import Transaction from "./components/transaction/transaction";
import UserLeave from "./components/leave/UserLeave";
import Announcement from "./components/announcement/Announcement";
import DetailAnnouncement from "./components/announcement/AnnouncementDetails";
import Award from "./components/award/Award";
import DetailAward from "./components/award/DetailsAward";
import LeavePolicy from "./components/leavePolicy/LeavePolicy";
import DetailLeavePolicy from "./components/leavePolicy/DetailsLeavePolicy";
import WeeklyHoliday from "./components/weeklyHoliday/WeeklyHoliday";
import DetailWeeklyHoliday from "./components/weeklyHoliday/DetailsWeeklyHoliday";
import PublicHoliday from "./components/publicHoliday/PublicHoliday";
import DetailPublicHoliday from "./components/publicHoliday/DetailsPublicHoliday";
import DetailPayslip from "./components/payroll/PayslipDetail";
import UserPrivateRoute from "./components/PrivateRoutes/UserPrivateRoute";
import AddAward from "./components/award/AddAward";
import GetAllAward from "./components/award/GetAllAward";
import Project from "./components/project/project";
import Milestone from "./components/project/milestone/milestone";
import TaskStatus from "./components/project/taskStatus/taskStatus";
import TaskPriority from "./components/project/taskPriority/taskPriority";
import DetailProjectTeam from "./components/project/team/DetailProjectTeam";
import UpdateMilestone from "./components/project/milestone/UpdateMilestone";
import ProjectTeam from "./components/project/team/ProjectTeam";
import UpdateTaskStatus from "./components/project/taskStatus/UpdateTaskStatus";
import UpdateTaskPriority from "./components/project/taskPriority/UpdateTaskPriority";
import Task from "./components/project/tasks/tasks";
import UpdateStatus from "./components/project/UpdateStatus";
import KanbanBoard2 from "./components/kanbanBoard/KanbanBoard2";
import Clients from "./components/Project Management/Client";
import ManageClients from "./components/Project Management/ManageClients";
import UpdateClient from "./components/Project Management/UpdateClient";
import Projects from "./components/Project Management/Projects";
import AddProject from "./components/Project Management/AddProject";
import ManageProject from "./components/Project Management/ManageProject";
import UpdateProject from "./components/Project Management/UpdateProject";

import Backlogs from "./components/Project Management/Backlogs";
import CreateTask from "./components/Project Management/CreateTask";
import ManageBacklog from "./components/Project Management/ManageBacklog";
import TransferTask from "./components/Project Management/TransferTask";

import Sprints from "./components/Project Management/Sprints";
import CreateSprint from "./components/Project Management/CreateSprint";
import ManageSprints from "./components/Project Management/ManageSprints";
import ProjectReportList from "./components/Project Management/Projectlist";
import TeamMemberReports from "./components/Project Management/TeamMemberReports";
import ManageTask from "./components/Project Management/ManageTask";
import NoticeBoard from "./components/Notice Board/NoticeBoard";
import NoticeDetails from "./components/Notice Board/NoticeDetails";
import ManageNotice from "./components/Notice Board/ManageNotice";
import UpdateNotice from "./components/Notice Board/UpdateNotice";
import Position from "./components/Employee/Position";
import ManagePosition from "./components/Employee/ManagePosition";
import RiskAssessment from "./components/Project Management/RiskAssessment";

import Timesheet from "./components/Timesheet";

// ADMIN
import InvoiceAttendance from "./components/Invoice/pages/InvoiceAttendance";
import Invoice from "./components/Invoice/Invoice";
import Reimbursement from "./components/Invoice/pages/Reimbursement";
import InvoiceDashboard from "./components/Invoice/pages/InvoiceDashboard";

// USER
import InvoiceUserAttendance from "./components/Invoice/pages/InvoiceUserAttendance";
import SubmittedExpenses from "./components/Invoice/pages/SubmittedExpenses";
import UserExpense from "./components/Invoice/pages/UserExpense";
import UserReimbursement from "./components/Invoice/pages/UserReimbursement"
import SubmittedForms from "./components/Invoice/pages/SubmittedForms";
import EmployeeSummary from "./components/Invoice/pages/EmployeeSummary";

import Email from "./components/email/pages/Email";

import Chat from "./components/chat/pages/Chat";
import Profile from "./components/chat/pages/Profile";
import GroupDetails from "./components/chat/pages/GroupDetails";



function App() {
	return (
		<div className='App container-fluid'>
			<ToastContainer
				position='bottom-left'
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme='light'
			/>
			<BrowserRouter>
				{/* <TestComp/> */}
				<Routes>
					<Route path="/" element={<Navigate to="/admin/auth/login" />} />
					{/* ===== PUBLIC ROUTES (NO MAIN LAYOUT) ===== */}
    				<Route path='/admin/auth/login' element={<Login />} />
    				<Route path='/admin/auth/register' element={<Register />} />
    				<Route path='/admin/auth/logout' element={<Logout />} />
					{/* ===== PROTECTED ROUTES (WITH MAIN LAYOUT) ===== */}
    				<Route path='/' element={<Main />}>
					{/* DASHBOARDS */}
            		<Route element={<UserPrivateRoute permission={"readAll-project"} />}>
              			<Route path="/admin/dashboard" element={<AdminDashboard />} />
            		</Route>
            		<Route element={<UserPrivateRoute permission={"readAll-project"} />}>
              			<Route path="/user/dashboard" element={<Dashboard />} />
            		</Route>
						


						
						<Route element={<UserPrivateRoute permission={"create-user"} />}>
							<Route path='/admin/hr/staffs/new' exact element={<UserList />} />
						</Route>
						<Route element={<UserPrivateRoute permission={"readAll-user"} />}>
							<Route path='/admin/hr/staffs' exact element={<GetAllUsers />} />
						</Route>
						<Route
							element={<UserPrivateRoute permission={"readSingle-user"} />}>
							<Route
								path='/admin/hr/staffs/:id'
								exact
								element={<DetailStaff />}
							/>
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"readAll-rolePermission"} />
							}>
							<Route path='/admin/role' exact element={<RoleList />} />
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"readSingle-rolePermission"} />
							}>
							<Route path='/admin/role/:id' element={<DetailRole />} />
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"create-rolePermission"} />
							}>
							<Route
								path='/admin/role/permit/:id/'
								element={<AddPermission />}
							/>
						</Route>
						<Route
							element={<UserPrivateRoute permission={"readAll-department"} />}>
							<Route path='/admin/department' exact element={<Department />} />
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"readSingle-department"} />
							}>
							<Route
								path='/admin/department/:id'
								element={<DetailDepartment />}
							/>
						</Route>
						<Route
							element={<UserPrivateRoute permission={"readAll-designation"} />}>
							<Route
								path='/admin/designation'
								exact
								element={<Designation />}
							/>
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-designation"} />
							}>
							<Route
								path='/admin/designation/:id'
								element={<DetailDesignation />}
							/>
						</Route>
						<Route
							element={<UserPrivateRoute permission={"update-designation"} />}>
							<Route
								path='/admin/designation/:id/update'
								element={<UpdateDesignation />}
							/>
						</Route>
						<Route
							element={<UserPrivateRoute permission={"readAll-setting"} />}>
							<Route
								path='/admin/company-setting'
								exact
								element={<InvoiceSetting />}
							/>
						</Route>

						{/* === === === Payroll Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readAll-payroll"} />}>
							<Route path='/admin/payroll/new' element={<CalculatePayroll />} />
							<Route path='/admin/payroll/list' element={<PayslipList />} />
						</Route>
						<Route
							element={<UserPrivateRoute permission={"readSingle-payroll"} />}>
							<Route path='/admin/payroll/:id' element={<DetailPayslip />} />
						</Route>

						{/* === === === Shift Routes === === === */}

						<Route element={<UserPrivateRoute permission={"readAll-shift"} />}>
							<Route path='/admin/shift' element={<Shift />} />
						</Route>

						<Route
							element={<UserPrivateRoute permission={"readSingle-shift"} />}>
							<Route path='/admin/shift/:id' element={<DetailShift />} />
						</Route>

						{/* === === === EmploymentStatus Routes === === === */}
						<Route
							element={
								<UserPrivateRoute permission={"readAll-employmentStatus"} />
							}>
							<Route
								path='/admin/employment-status'
								element={<EmploymentStatus />}
							/>
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-employmentStatus"} />
							}>
							<Route
								path='/admin/employment-status/:id'
								element={<DetailEmploymentStatus />}
							/>
						</Route>

						{/* === === === Leave Routes === === === */}

						<Route
							element={
								<UserPrivateRoute permission={"create-leaveApplication"} />
							}>
							<Route path='/admin/leave/new' element={<Leave />} />
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"readAll-leaveApplication"} />
							}>
							<Route path='/admin/leave/:id' element={<DetailLeave />} />
							<Route path='/admin/leave' element={<GetAllLeaves />} />
						</Route>
						<Route
							element={
								<UserPrivateRoute permission={"readSingle-leaveApplication"} />
							}>
							<Route path='/admin/leave/user/:id' element={<UserLeave />} />
						</Route>
						{/* === === === Attendance Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readAll-attendance"} />}>
							<Route path='/admin/attendance' element={<Attendance />} />
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-attendance"} />
							}>
							<Route
								path='/admin/attendance/user/:id'
								element={<UserAttendance />}
							/>
						</Route>
						{/*<Route
							path='/admin/attendance/:id'
							element={<DetailAttendance />}
						/> */}

						{/* === === === Accounting Routes === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-account"} />}>
							<Route path='/admin/account' exact element={<Account />} />
							<Route path='/admin/account/:id' element={<DetailAccount />} />
							<Route
								path='/admin/account/trial-balance'
								exact
								element={<TrialBalance />}
							/>
							<Route
								path='/admin/account/balance-sheet'
								exact
								element={<BalanceSheet />}
							/>
							<Route
								path='/admin/account/income'
								exact
								element={<IncomeStatement />}
							/>
						</Route>
						{/* === === === Transaction Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readAll-transaction"} />}>
							<Route
								path='/admin/transaction'
								exact
								element={<Transaction />}
							/>
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-transaction"} />
							}>
							<Route
								path='/admin/transaction/:id'
								element={<DetailTransaction />}
							/>
						</Route>
						<Route
							element={<UserPrivateRoute permission={"create-transaction"} />}>
							<Route
								path='/admin/transaction/create'
								exact
								element={<AddTransaction />}
							/>
						</Route>

						{/* === === === Announcement Routes === === === */}
						<Route
							element={
								<UserPrivateRoute permission={"readAll-announcement"} />
							}>
							<Route
								path='/admin/announcement'
								exact
								element={<Announcement />}
							/>
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-announcement"} />
							}>
							<Route
								path='/admin/announcement/:id'
								element={<DetailAnnouncement />}
							/>
						</Route>

						{/* === === === Award Routes === === === */}

						<Route element={<UserPrivateRoute permission={"create-award"} />}>
							<Route path='/admin/award/new' exact element={<AddAward />} />
						</Route>
						<Route element={<UserPrivateRoute permission={"readAll-award"} />}>
							<Route path='/admin/award/:id' element={<DetailAward />} />
							<Route path='/admin/award' exact element={<GetAllAward />} />
						</Route>

						{/* === === === Leave Policy Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readAll-leavePolicy"} />}>
							<Route
								path='/admin/leave-policy'
								exact
								element={<LeavePolicy />}
							/>
							<Route
								path='/admin/leave-policy/:id'
								element={<DetailLeavePolicy />}
							/>
						</Route>

						{/* === === === Weekly Holiday Routes === === === */}
						<Route
							element={
								<UserPrivateRoute permission={"readAll-weeklyHoliday"} />
							}>
							<Route
								path='/admin/holiday/week'
								exact
								element={<WeeklyHoliday />}
							/>
							<Route
								path='/admin/holiday/week/:id'
								element={<DetailWeeklyHoliday />}
							/>
						</Route>
						{/* === === === Public Holiday Routes === === === */}
						<Route
							element={
								<UserPrivateRoute permission={"readAll-publicHoliday"} />
							}>
							<Route
								path='/admin/holiday/public'
								exact
								element={<PublicHoliday />}
							/>
							<Route
								path='/admin/holiday/public/:id'
								element={<DetailPublicHoliday />}
							/>
						</Route>

						{/* === === === === PROJECT MANAGEMENT STARTED HERE === === === ===*/}


						/* === === === New Routes === === === */

						<Route
  							element={<UserPrivateRoute permission={"readAll-client"} />}
						>
  							<Route path="/admin/clients" element={<Clients />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"readAll-client"} />}
						>
  							<Route path="/admin/manage-clients" element={<ManageClients />} />
						</Route>

						<Route
							element={<UserPrivateRoute permission={"readAll-client"} />}
						>
							<Route path="/admin/update-client/:id" element={<UpdateClient />} />
						</Route>

						/* === === === Project Management Custom Pages === === === */

						<Route
  							element={<UserPrivateRoute permission={"readAll-project"} />}
						>
  							<Route path="/admin/projects" element={<Projects />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"create-project"} />}
						>
  							<Route path="/admin/add-project" element={<AddProject />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"readAll-project"} />}
						>
  							<Route path="/admin/manage-project" element={<ManageProject />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"update-project"} />}
						>
  							<Route
    							path="/admin/update-project/:projectId"
    							element={<UpdateProject />}
  							/>
						</Route>
						<Route
  							element={<UserPrivateRoute permission={"readAll-project"} />}
						>
  							<Route path="/admin/backlogs/:projectId" element={<Backlogs />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"create-task"} />}
						>
  							<Route path="/admin/create-task/:projectId" element={<CreateTask />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"readAll-task"} />}
						>
  							<Route
    							path="/admin/manage-backlog/:projectId"
    							element={<ManageBacklog />}
  							/>
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"update-task"} />}
						>
  							<Route
    							path="/admin/transfer-task/:projectId"
    							element={<TransferTask />}
  							/>
						</Route>
						<Route
  							element={<UserPrivateRoute permission={"readAll-project"} />}
						>
  							<Route path="/admin/sprints/:projectId" element={<Sprints />} />
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"create-sprint"} />}
						>
  							<Route
    							path="/admin/create-sprint/:projectId"
    							element={<CreateSprint />}
  							/>
						</Route>

						<Route
  							element={<UserPrivateRoute permission={"readAll-sprint"} />}
						>
  							<Route
    							path="/admin/manage-sprints/:projectId"
    							element={<ManageSprints />}
  							/>
							</Route>

						<Route
  							element={<UserPrivateRoute permission={"readAll-project"} />}
						>
  							<Route path="/admin/risk/:projectId" element={<RiskAssessment />} />
							</Route>

						{/* REPORTS */}
            			<Route element={<UserPrivateRoute permission={"readAll-project"} />}>
              				<Route path="/admin/reports/project-list" element={<ProjectReportList />} />
              				<Route path="/admin/reports/team-member" element={<TeamMemberReports />} />
              				<Route path="/admin/manage-task" element={<ManageTask />} />
            			</Route>

						{/*Notice board*/}
            			<Route path="/admin/notice-board" element={<NoticeBoard />} />
            			<Route path="/admin/notice-details/:id" element={<NoticeDetails />} />
            			<Route path="/admin/manage-notice" element={<ManageNotice />} />
            			<Route path="/admin/update-notice/:id" element={<UpdateNotice />} />


            			{/*Employee*/}
            			<Route path="/admin/position" element={<Position />} />
            			<Route path="/admin/manage-position" element={<ManagePosition />} />

						{/* === === === Kanban Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readSingle-project"} />}>
							<Route
								path='/admin/kanban/:projectId'
								element={<KanbanBoard2 />}
							/>
						</Route>
						{/* <Route
							path='/admin/kanban2/:projectId'
							element={<KanbanBoard2 />}
						/>
 */}
						{/* === === === Project Routes === === === */}
						<Route
							element={<UserPrivateRoute permission={"readAll-project"} />}>
							<Route path='/admin/project' element={<Project />} />
						</Route>

						<Route element={<UserPrivateRoute permission={"create-project"} />}>
							<Route path='/admin/project/new' element={<AddProject />} />
						</Route>

						<Route element={<UserPrivateRoute permission={"update-project"} />}>
							<Route
								path='/admin/project/update/:projectId'
								element={<UpdateProject />}
							/>
						</Route>

						<Route
							path='/admin/project/update/:projectId/status'
							element={<UpdateStatus />}
						/>

						{/* === === === Project Milestone === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-project"} />}>
							<Route
								path='/admin/project/:id/milestone'
								element={<Milestone isFixed={true} />}
							/>
						</Route>

						{/* === === === Project Task Status === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-project"} />}>
							<Route
								path='/admin/project/:id/task-status'
								element={<TaskStatus isFixed={true} />}
							/>
						</Route>

						{/* === === === Team Routes === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-projectTeam"} />}>
							<Route path='/admin/team' element={<ProjectTeam />} />
						</Route>

						<Route
							element={
								<UserPrivateRoute permission={"readSingle-projectTeam"} />
							}>
							<Route path='/admin/team/:id' element={<DetailProjectTeam />} />
						</Route>
						{/* <Route path='/admin/team/update/:id' element={<DetailProjectTeam />} /> */}

						{/* === === === Milestone Routes === === === */}

						<Route
							element={<UserPrivateRoute permission={"create-milestone"} />}>
							<Route path='/admin/milestone' element={<Milestone />} />
						</Route>

						<Route
							element={<UserPrivateRoute permission={"update-milestone"} />}>
							<Route
								path='/admin/milestone/update/:id'
								element={<UpdateMilestone />}
							/>
						</Route>

						{/* <Route path="/admin/milestone/:id" element={<DetailProject />} /> */}

						<Route element={<UserPrivateRoute permission={"create-task"} />}>
							<Route path='/admin/task' element={<Task />} />
						</Route>

						{/* === === === TaskStatus Routes === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-taskStatus"} />}>
							<Route path='/admin/task-status' element={<TaskStatus />} />
						</Route>

						<Route
							element={<UserPrivateRoute permission={"update-taskStatus"} />}>
							<Route
								path='/admin/task-status/update/:id'
								element={<UpdateTaskStatus />}
							/>
						</Route>

						{/* === === === TaskPriority Routes === === === */}

						<Route
							element={<UserPrivateRoute permission={"readAll-priority"} />}>
							<Route path='/admin/task-priority' element={<TaskPriority />} />
						</Route>

						<Route
							element={<UserPrivateRoute permission={"update-priority"} />}>
							<Route
								path='/admin/task-priority/update/:id'
								element={<UpdateTaskPriority />}
							/>
						</Route>

						<Route path="/timesheet" element={<Timesheet />} />
  						{/* ADMIN ROUTES */}
  						<Route path="/admin/invoice/attendance" element={<InvoiceAttendance />} />
  						<Route path="/admin/invoice" element={<Invoice />} /> {/* if same page OR create AdminExpense */}
  						<Route path="/admin/invoice/reimbursement" element={<Reimbursement />} />
						<Route path="/admin/invoice-dashboard" element={<InvoiceDashboard />} />
						<Route path="/employee/:id" element={<EmployeeSummary />} />

  						{/* USER ROUTES */}
  						<Route path="/user/invoice/attendance" element={<InvoiceUserAttendance />} />
  						<Route path="/user/invoice/expense" element={<UserExpense />} />
						<Route path="/submittedexpenses" element={<SubmittedExpenses />}/>
  						<Route path="/user/invoice/reimbursement" element={<UserReimbursement />} />
						<Route path="/submittedforms" element={<SubmittedForms />} />
						
						<Route path="/chat" element={<Chat />} />
						<Route path="/email" element={<Email />} />
						<Route path="/profile" element={<Profile />} />
						<Route
  							path="/group/:groupName"
  							element={<GroupDetails />}
						/>
					</Route>  

						{/* <Route path='/admin/project-team' eclement={<ProjectTeam />} /> */}

						{/* === === === Task Routes === === === */}
						{/* <Route path="/admin/task" element={<Task />} /> */}
						{/* <Route path="/admin/task/:id" element={<DetailTask />} />  */}
					</Routes>
					
			</BrowserRouter>
		</div>
	);
}

export default App;
